import { RefiDocViewer } from './doc-viewer.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';
import '../../lit-element.js';

defineRefiElement('refi-common-doc-viewer', RefiDocViewer);
